import React from 'react';
import { Link } from 'react-router-dom';
import { ANNOUNCEMENT } from '../../constants/campConfig';

const Announcement = () => {
  return (
    <div>
      <div id="news-bar" className="box cta mb-0">
        <p className="has-text-centered has-text-weight-semibold">
          <span className="tag is-info">{ANNOUNCEMENT.badge}</span> {ANNOUNCEMENT.message}{' '}
          <Link to={ANNOUNCEMENT.button.link} className="button is-black is-outlined is-small has-text-weight-semibold">
            {ANNOUNCEMENT.button.text}
          </Link>
        </p>
      </div>
    </div>
  );
};

export default Announcement;
